export class IdGenerator {
  constructor(maxId = 10000) {
    this.currId = 0;
    this.maxId = maxId;
  }

  generateNextId() {
    this.currId = (this.currId + 1) % this.maxId;
    return this.currId;
  }
}
